import EdInstitutionCalendarComponent from './ed-institution-calendar/ed-institution-calendar.component.vue';
import ToolsToolbar from './tools-toolbar/tools-toolbar.vue';

export const ToolsComponents = {
  ToolsToolbar,
  EdInstitutionCalendarComponent,
}
